/**
 * The privacy page route (D2b, PR #83). Nest it inside <ProtectedRoute /> so auth has
 * loaded first. A named DPO needs no compliance role (owner decision D2-O1), so the page
 * admits compliance:read holders and anyone the DPO-access endpoint lets see DSAR and
 * breach records; everyone else goes to /unauthorized. The page itself hides the
 * registers a user cannot read, and every API checks again server-side.
 */
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGetDpoAccessQuery } from '../../entities/deadlines/api/deadlinesApi';

export default function PrivacyRoute() {
  const permissions = useSelector((state) => state.auth?.permissions || []);
  const location = useLocation();
  const list = Array.isArray(permissions) ? permissions : [];
  const canReadCompliance = list.includes('compliance:read') || list.includes('super:admin');
  const { data, isLoading } = useGetDpoAccessQuery(undefined, { skip: canReadCompliance });

  if (canReadCompliance) return <Outlet />;
  if (isLoading) return null;
  if (data?.can_see) return <Outlet />;
  // refused, or the check failed: fail closed
  return <Navigate to="/unauthorized" state={{ from: location }} replace />;
}
